import * as React from "react";
import type { SVGProps } from "react";
const SvgUmbrella = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#umbrella_svg__a)">
      <path d="M21 22H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1M8.73 14.9c-.36 0-.71-.19-.89-.54-2.11-4.04-3.2-9.07-.58-10.58s6.44 1.95 8.88 5.81c.3.47.16 1.08-.31 1.38-.46.3-1.08.16-1.38-.31-2.5-3.96-5.3-5.67-6.19-5.15-.9.52-.82 3.79 1.36 7.93.26.49.07 1.09-.42 1.35-.15.08-.31.11-.46.11z" />
      <path d="M3.81 17.75c-.39 0-.75-.23-.91-.59C.73 12.32 2.65 6.44 7.26 3.78s10.65-1.39 13.76 2.9c.24.32.27.76.06 1.11-.23.39-.7.58-1.14.45-.5-.15-1.48-.32-2.34.17-.3.17-1.02.7-1.32 1.95a.99.99 0 0 1-1.15.75c-.53-.09-1.91-.23-3.3.57-1.27.74-1.87 1.8-2.15 2.57-.18.5-.72.77-1.22.62-.51-.15-1.49-.33-2.35.16-.37.21-1.04.75-1.32 1.94a.99.99 0 0 1-.88.76h-.09zm8.68-13.37c-1.45 0-2.91.36-4.23 1.12-3.05 1.77-4.65 5.27-4.17 8.63.37-.4.74-.65 1.02-.82.88-.51 1.94-.69 3.04-.54.6-1.18 1.51-2.14 2.68-2.81 1.42-.82 2.83-.95 3.78-.9.58-1.42 1.55-2.12 1.99-2.37.4-.23.82-.39 1.21-.48a8.65 8.65 0 0 0-5.32-1.82z" />
      <path d="M7.76 5.64c-.35 0-.68-.18-.87-.5L5.94 3.5c-.28-.48-.11-1.09.37-1.37s1.09-.11 1.37.37l.95 1.64a1.002 1.002 0 0 1-.87 1.5M17.16 21.92c-.35 0-.68-.18-.87-.5l-5.61-9.71c-.28-.48-.11-1.09.37-1.37s1.09-.11 1.37.37l5.61 9.71a1.002 1.002 0 0 1-.87 1.5" />
    </g>
    <defs>
      <clipPath id="umbrella_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgUmbrella;
